export enum HTTPErrors {
  badRequest = 400,
  unauthenticated = 401,
  forbidden = 403,
  notFound = 404,
  internalServerError = 500,
  serviceUnavailable = 503,
  gatewayTimeout = 504,
  directLoginDisabled = 424,
  tokenInvalid = 401,
  userNotRosteredInDistrict = 403,
}

export enum CustomErrorCodes {
  noSchools = 'noSchools',
  invalidLicense = 'invalidLicense',
  notRostered = 'notRostered',
  ltiUnknownError = 'lti-unknown-error',
  ltiConfigurationError = 'lti-configuration-error',
  ltiDataError = 'lti-data-error',
  unknownError = 'unknown-error',
  userExpInProgress = 'userExpInProgress',
  directLoginDisabled = 'direct-login-disabled',
  tokenInvalid = 'token-invalid',
  userNotRosteredInDistrict = 'user-not-rostered-in-district',
  tokenExpired = 'token-expired',
}

export enum CustomExceptions {
  userNotFound = 'UserNotFoundException',
  notAuthorized = 'NotAuthorizedException',
  codeMismatch = 'CodeMismatchException',
  expiredCode = 'ExpiredCodeException',
  limitExceeded = 'LimitExceededException',
}
